import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Card, CardContent, Button, Input } from "@tabipla/ui";
import { usePackingForm } from "./PackingContext";

export function AddPackingItemForm() {
  const { t } = useTranslation();
  const { newItemName, isCreating, onNewItemNameChange, onAddItem } = usePackingForm();

  return (
    <Card>
      <CardContent className="p-3">
        <form onSubmit={onAddItem} className="flex items-center gap-2">
          <Input
            value={newItemName}
            onChange={(e) => onNewItemNameChange(e.target.value)}
            placeholder={t("packing.addItemPlaceholder")}
            className="flex-1"
          />
          <Button
            type="submit"
            size="icon"
            className="h-10 w-10 shrink-0"
            disabled={!newItemName.trim() || isCreating}
          >
            <Plus className="h-4 w-4" />
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
